import { IProcessing } from "../../types";

export const FormatValueCalc = (
  format = "",
  value1 = null,
  value2 = value1,
) => {
  const val = (value1 * value2) / 1000000;
  if (!!value1 || !!value2) {
    if (format === "Круг" && value1 > 149) return val * 1.35;
    else if (!!value2 && value1 > 149 && value2 > 149) {
      if (format === "Фигура") return val * 1.35;
      return val;
    } else return 1;
  } else return 1;
};
export const MaterialValueCalc = (
  formatValue: number = null,
  materialPrice: number = null,
) => {
  return materialPrice ? materialPrice * formatValue : 0;
};
export const RunningMeter = (f1: number, f2: number = null) =>
  f2 === null ? f1 / 250 : f1 / 500 + f2 / 500;

export const ProcessingValueCalc = (
  processing: IProcessing[] = null,
  hasFormat: string = null,
  hasDepth: string = null,
  hasProcessing: string = null,
  hasFormatValue1: number = null,
  hasFormatValue2: number = null,
  hasProcessingValue = null,
) => {
  if (
    !!hasDepth &&
    !!hasProcessing &&
    !!hasFormatValue1 &&
    processing?.length
  ) {
    const proc = processing.find((el) => el.title === hasProcessing);
    let defaultPriceDepth = proc?.processing_depths?.find(
      (el) => el.millimetre.toString() === hasDepth,
    )?.defaultPrice;
    const priceAdditional = proc?.processing_depths
      ?.find((el) => el.millimetre.toString() === hasDepth)
      ?.processing_prices?.find((el) => el.title === hasProcessingValue)?.price;
    const pl = RunningMeter(
      hasFormatValue1,
      hasFormat === "Круг" ? null : hasFormatValue2,
    );
    if (!priceAdditional && hasFormat != "Прямоугольник" && defaultPriceDepth) {
      defaultPriceDepth = hasFormat === "Круг" ? 450 : 900;
    }
    return pl * (priceAdditional || defaultPriceDepth || proc.defaultPrice);
    //todo: написать в заметках, что убрано дополнение с полировкой
    /*if (hasProcessing === 'Фацет' && !!hasProcessingValue) y = pl * (processing[hasProcessing][hasDepth][hasProcessingValue] + processing["Полировка"][hasDepth])
    else if (hasProcessing === 'Полировка') y = pl * processing[hasProcessing][hasDepth]*/
  } else return 0;
};
